<div class="collector-field">
  <input
    type="text"
    class="form-control"
    [placeholder]="'Type collector name'"
    [formControl]="collectorControl"
    [matAutocomplete]="collectorAutoComplete"
    (blur)="handleBlur()"
  />

  <button
    *ngIf="collectorControl.value"
    type="button"
    class="collector-clear-btn"
    aria-label="Clear"
    [disabled]="disabled"
    (click)="$event.stopPropagation(); clear()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-autocomplete
    #collectorAutoComplete="matAutocomplete"
    [displayWith]="displayUser"
    (optionSelected)="selectionChange($event.option.value)"
  >
    <mat-option
      *ngFor="let user of filteredUsers$ | async"
      [value]="user"
      [disabled]="user.eligible === false"
      [class.collector-option--ineligible]="user.eligible === false"
      [class.collector-option--force-enabled]="
        allowForceSelection && user.eligible === false
      "
    >
      <div class="collector-option">
        <div class="collector-option__details">
          <span class="collector-option__name">
            {{ user.name
            }}<ng-container *ngIf="user.email"> ({{ user.email }})</ng-container>
          </span>
          <ul
            class="collector-option__reasons"
            *ngIf="user.eligible === false && user.ineligibilityReasons?.length"
          >
            <li *ngFor="let reason of user.ineligibilityReasons">
              {{ reason.message }}
            </li>
          </ul>
        </div>

        <button
          *ngIf="allowForceSelection && user.eligible === false"
          type="button"
          class="collector-force-btn"
          [attr.aria-label]="'Force assign ' + user.name"
          matTooltip="Force assignment"
          matTooltipPosition="left"
          (mousedown)="preventForceButtonFocus($event)"
          (click)="forceSelection(user, $event)"
        >
          <mat-icon>bolt</mat-icon>
        </button>
      </div>
    </mat-option>
  </mat-autocomplete>
</div>
